import { FieldPattern } from '..';

import { CONTENT } from '../../../../constants/FieldTypeConstants';

import FormFieldWithInitialValue from '../FormFieldWithInitialValue';

class ContentField extends FormFieldWithInitialValue {
  readonly type: string = CONTENT;

  match<T>(p: FieldPattern<T>): T {
    return p.ContentField(this);
  }
}

export default ContentField;
